import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { RelNotesComponent } from './rel-notes/rel-notes.component';
import { TacSupportComponent } from './tac-support/tac-support.component';
import { SortDirective } from './directive/sort.directive';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NewrequestComponent } from './newrequest/newrequest.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import {MatChipsModule} from '@angular/material/chips';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {NgxPageScrollModule} from 'ngx-page-scroll';
import {GoogleAnalyticsService} from "./services/google-analytics.service";
import { MyFilterPipe } from './directive/filterpipe';
import {MatExpansionModule} from '@angular/material/expansion';
import { FingerprintidComponent } from './fingerprintid/fingerprintid.component';
import { CustomDetectorComponent } from './custom-detector/custom-detector.component';
import { SidenavHeaderComponent } from './sidenav-header/sidenav-header.component';
import { TopNavbarComponent } from './top-navbar/top-navbar.component';
import { SplitCommaStringPipe } from './splitCommaStringPipe';
import { CustomeDetectorUpdateComponent } from './custome-detector-update/custome-detector-update.component';
import { DataService } from './services/data.service';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    RelNotesComponent,
    TacSupportComponent,
    SortDirective,
    NewrequestComponent,
    HeaderNavComponent,
    MyFilterPipe,
    FingerprintidComponent,
    CustomDetectorComponent,
    SidenavHeaderComponent,
    TopNavbarComponent,
    SplitCommaStringPipe,
    CustomeDetectorUpdateComponent
    

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    NoopAnimationsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    ScrollingModule,
    NgxPageScrollModule,
    MatExpansionModule
  ],
  providers: [
    GoogleAnalyticsService,DataService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
